import { createContext, useMemo, useRef, type ReactNode } from 'react'

type Reload = () => Promise<void>
export const OpportunityRefreshContext = createContext<{
  register: (reload: Reload) => () => void
  refresh: Reload
} | null>(null)

// Scope invalidation to the currently open Opportunity. Reloads only read records;
// they never refresh or replace the persisted Opening/Pricing Item snapshots.
export function OpportunityRefreshProvider({ children }: { children: ReactNode }) {
  const loaders = useRef(new Set<Reload>())
  const value = useMemo(() => ({
    register(reload: Reload) {
      loaders.current.add(reload)
      return () => { loaders.current.delete(reload) }
    },
    async refresh() { await Promise.all([...loaders.current].map((reload) => reload())) },
  }), [])
  return <OpportunityRefreshContext.Provider value={value}>{children}</OpportunityRefreshContext.Provider>
}
